var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-button',{staticClass:"btn",class:{
  'btn-block': _vm.block,
  'btn-loading': _vm.loading
},attrs:{"type":_vm.nativeType,"variant":_vm.variant,"disabled":_vm.loading || _vm.disabled,"size":_vm.size},on:{"click":_vm.click}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }